/** Production site origin for absolute canonical URLs. */
export const SITE_ORIGIN = 'https://sidestreet.io'

/**
 * One canonical URL per path: trailing slash on all non-root paths, each segment
 * encoded with encodeURIComponent (matches sitemap / prerender for city names).
 */
export function buildSidestreetCanonical(pathname) {
  if (!pathname || pathname === '/') return `${SITE_ORIGIN}/`
  const trimmed = pathname.replace(/\/+$/, '') || '/'
  if (trimmed === '/') return `${SITE_ORIGIN}/`
  const segments = trimmed.split('/').filter(Boolean)
  const encoded = segments.map((s) => encodeURIComponent(s)).join('/')
  return `${SITE_ORIGIN}/${encoded}/`
}
